export const LOGIN_REQUESTING = 'LOGIN_REQUESTING'
export const CLEAR_MESSAGES = 'LOGIN.CLEAR_MESSAGES'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_EXISTING = 'LOGIN_EXISTING'
export const LOGOUT = 'LOGOUT'
export const LOGIN_URL = '/api/v1/users/sign_in'
export const LOGIN_REDIRECT = '/#/dashboard'


// WEBPACK FOOTER //
// ./src/views/Pages/Login/constants.js